export default __webpack_public_path__ + "static/media/dotnetcore.015330fa.svg";